import { shallowEqual, useSelector } from 'react-redux';

import {
  FILTER_LOCATION_NAME,
  FILTER_POSTAL_CODE,
  LOCATION_REDIRECT
} from 'dpl/constants/query_params';

const SEARCH_LOCATION_SOURCES = {
  URL_PARAMETER: 'url_parameter',
  IP_DETECTED: 'ip_detected',
  USER_SET: 'user_set'
};

/**
 * react-redux 9 types the selector state as `unknown`, which would make the
 * inferred return type `unknown` for TypeScript callers.
 * @returns {{ locationName: string | null, locationSource: string | null }}
 */
export default function useSearchLocation() {
  const { locationTitle } = useSelector(({ server }) => server);

  return useSelector(({ queryParams }) => {
    const isLocationRedirect = queryParams[LOCATION_REDIRECT] === 'true';

    if (queryParams[FILTER_POSTAL_CODE]) {
      return {
        locationSource: isLocationRedirect
          ? SEARCH_LOCATION_SOURCES.IP_DETECTED
          : SEARCH_LOCATION_SOURCES.URL_PARAMETER,
        locationName: queryParams[FILTER_POSTAL_CODE]
      };
    }

    if (queryParams[FILTER_LOCATION_NAME]) {
      return {
        locationSource: SEARCH_LOCATION_SOURCES.USER_SET,
        locationName: decodeURIComponent(queryParams[FILTER_LOCATION_NAME])
      };
    }

    if (!isLocationRedirect) {
      return {
        locationSource: SEARCH_LOCATION_SOURCES.URL_PARAMETER,
        locationName: locationTitle
      };
    }

    return { locationName: null, locationSource: null };
  }, shallowEqual);
}
